import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FileUploadInput, FileUploadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = FileUploadInput;
type TData = FileUploadPayload;

export const useTranslationRequestFileUpload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestFileUpload($input: FileUploadInput!) {
      translationRequestFileUpload(input: $input) {
        success
        files {
          filename
          uid
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
